module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "media-list"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "bottom"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {
    staticClass: "breadcrumb-bar"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/contentSection'
      }
    }
  }, [_vm._v("内容专区运营")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("\n              " + _vm._s(_vm.rid ? "编辑版块" : "新建版块"))])], 1)], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "main-box"
  }, [_c('Card', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "panel-box"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("版块基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.showPlate,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "版块名称:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.showPlate.name),
      callback: function($$v) {
        _vm.$set(_vm.showPlate, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "showPlate.name"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择资源类型:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.showPlate.levelValue),
      callback: function($$v) {
        _vm.$set(_vm.showPlate, "levelValue", $$v)
      },
      expression: "showPlate.levelValue"
    }
  }, _vm._l((_vm.levelList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.showPlate.levelValue != 3) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.showPlate.levelValue == 3) ? _c('p', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold",
      "margin-left": "40px"
    }
  }, [_vm._v("*听力熊T3，T4系列不支持多层专辑显示")]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "添加资源:"
    }
  }, [_vm._l((_vm.showPlate.resourceList), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "width": "500px"
      }
    }, [_c('el-row', {
      staticStyle: {
        "margin-bottom": "8px"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 10
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#2222dd"
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#2222dd"
      }
    }, [(item.layerType == 1) ? _c('span', [_vm._v("单层专辑")]) : _vm._e(), (item.layerType == 2) ? _c('span', [_vm._v("多层专辑")]) : _vm._e()])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.delRight(index)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "type": "ios-remove-circle-outline",
        "size": "30",
        "color": "#C5C5C5"
      }
    })], 1)])], 1)], 1)
  }), _vm._v(" "), _c('addClassResource', {
    attrs: {
      "typeValue": _vm.showPlate.levelValue
    },
    on: {
      "changeResource": _vm.clickRecource
    }
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "版块图片"
    }
  }, [_c('el-row', {
    staticClass: "row-bg",
    staticStyle: {
      "width": "780px"
    }
  }, [_c('el-col', {
    staticClass: "picture-container",
    class: {
      'limt-1': _vm.showPlate.imgUrl
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-upload', {
    ref: "uploadxls",
    attrs: {
      "list-type": "picture-card",
      "limit": 1,
      "fileList": _vm.fileList,
      "action": "/aries-api/resource/upload",
      "before-upload": _vm.onBeforeUpload,
      "on-success": _vm.onSuccessUpload,
      "data": _vm.uploadData,
      "auto-upload": true
    },
    scopedSlots: _vm._u([{
      key: "file",
      fn: function(ref) {
        var file = ref.file;

        return _c('div', {}, [_c('img', {
          staticClass: "el-upload-list__item-thumbnail",
          attrs: {
            "src": _vm.showPlate.imgUrl,
            "alt": ""
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "el-upload-list__item-actions"
        }, [_c('span', {
          staticClass: "el-upload-list__item-delete",
          on: {
            "click": function($event) {
              return _vm.handleRemove(file)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])])])
      }
    }])
  }, [_c('i', {
    staticClass: "el-icon-upload",
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text upload__tip",
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("\n                      *上传图片尺寸为220*72\n                    ")])])], 1)], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "background-color": "#009e7d",
      "margin-top": "20px",
      "width": "220px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.createShow
    }
  }, [_vm._v("设计图片")])], 1), _vm._v(" "), _c('br')], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.cencel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "background-color": "#009e7d"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmSubmit
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('create-picture', {
    on: {
      "getData": _vm.getData
    },
    model: {
      value: (_vm.pickShow),
      callback: function($$v) {
        _vm.pickShow = $$v
      },
      expression: "pickShow"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43f1293d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/addSection.vue
// module id = 682
// module chunks = 1